import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, callGameServerApi, getInlineLoader, isAlphanumeric, resolveOrientation } from '../Helpers';
import chess_pieces from '../assets/chess_pieces.png';
import logo_wide from '../assets/logo_wide.png';
import { IoEnterOutline } from 'react-icons/io5';
import { MdArrowBack } from 'react-icons/md'
import TopBar from '../components/TopBar';
import { GAME_TYPES, PLAY_MODES } from '../Constants';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "landscape";
  const [ error, setError ] = useState(false);
  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  const [ selectedGame, setSelectedGame ] = useState(null);
  const [ gameId, setGameId ] = useState("");

  

  const init = () => {
    appContext.changeOrientation(requiredOrientation);
    setReady(true);
  }


  const createMatch = async () => {
    //create match for the selected game
    if(!loading) {
      setError(false);
      setLoading(true);
      let user = await appContext.getLocalUser();
      //console.log(user);
      await callGameServerApi(
        'create-game', 
        { 
          playerId: user.userId,
          userToken: user.userToken,
          invitedId: null,
          playMode: PLAY_MODES.ONLINE,
          gameType: selectedGame,
        }).then(response => {
        if(response.status === 1) {
          appContext.navTo({
            item: 'browse_game',
            subItem: response.uid,
          });
        } else {
          setLoading(false);
          appContext.tellError(response.msg);
          setError(response.msg);
        }
      })
    }
  }

  const checkGameId = async () => {
    if(gameId.trim().length >= 4) {
      setLoading(true);
      await callGameServerApi('check-game-id', { gameId }).then(response => {
        setLoading(false);
        if(response.status === 1) {
          //redirect
          appContext.navTo({
            item: 'browse_game',
            subItem: gameId,
          });
        } else {
          appContext.tellError(response.msg);
        }
      })
    } else {
      appContext.tellError('Invalid Game ID')
    }
  }


  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();

    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  return (
    <>
      <TopBar title="New Checkers Game" />
      <div className="FullPane"  data-support-top-bar={true}>
        <div className='container'>
          <div className='row'>
            
            <div className='col-md-6' style={{ marginTop: "30px", marginBottom:"30px" }}>
              <div className='row'>

                <div className='col-12'>
                  <h6 className='text-goldish font-light' style={{ fontSize: "20px", marginBottom: "20px" }}>Select Checkers Type to create</h6>
                </div>

                <div className='col-6'>
                  <button onClick={() => setSelectedGame(GAME_TYPES.BRAZILIAN_CHECKERS)} className='btn btn-block bg-goldish mNoMargin'>Brazilian</button>
                </div>

                <div className='col-6'>
                  <button onClick={() => setSelectedGame(GAME_TYPES.SPANISH_CHECKERS)} className='btn btn-block bg-redish mNoMargin'>Spanish</button>
                </div>

                <div className='col-12' style={{ marginTop: "20px" }}>
                  {
                    (selectedGame === null) ?
                    <div className='row'>
                      <div className='col-12 text-center'>
                        <img src={chess_pieces} width="100%"  />
                      </div>
                    </div>: <></>
                  }

                  {
                    (selectedGame === GAME_TYPES.BRAZILIAN_CHECKERS) ?
                    <div className='row'>
                      <div className='col-12 text-end' style={{ marginTop: "10px" }}>
                        <h3>Brazilian Checkers</h3>
                      </div>

                      <div className='col-12 text-start'>
                        <small className='text-muted'>
                          Kwenye aina hii ya draft, kete ya kawaida inaweza kula KETE YA NYUMA AU MBELE. Kingi pia inaweza kula mbele na nyuma
                          pamoja na kuruka vyumba kama viko tupu.
                        </small>
                      </div>

                      {
                        (error) ?
                        <div className='col-12 text-start' >
                          <h6 className='text-redish font-light' style={{ fontSize: "12px" }}>
                            {error}
                          </h6>
                        </div> : <></>
                      }

                      <div className='col-12 text-end' >
                        <button
                          onClick={() => {
                            appContext.activateDialog({
                              message: "Create and host a match for Brazilian Checkers",
                              onConfirm: createMatch,
                            })
                          }}
                          className='btn bg-goldish btn-rounded'>
                          Create & Host
                        </button>
                      </div>

                    </div> : <></>
                  }

                  {
                    (selectedGame === GAME_TYPES.SPANISH_CHECKERS) ?
                    <div className='row'>

                      <div className='col-12 text-end' style={{ marginTop: "10px" }}>
                        <h3>Spanish Checkers</h3>
                      </div>

                      <div className='col-12 text-start'>
                        <small className='text-muted'>
                          Kwenye aina hii ya draft, kete ya kawaida inaweza kula KETE YA MBELE YAKE TU. Kingi pekee inaweza kula mbele na nyuma
                          pamoja na kuruka vyumba kama viko tupu.
                        </small>
                      </div>

                      

                      {
                        (error) ?
                        <div className='col-12 text-start' >
                          <h6 className='text-redish font-light' style={{ fontSize: "12px" }}>
                            {error}
                          </h6>
                        </div> : <></>
                      }

                      <div className='col-12 text-end' >
                        <button
                          onClick={() => {
                            appContext.activateDialog({
                              message: "Create and host a match for Spanish Checkers",
                              onConfirm: createMatch,
                            })
                          }}
                          className='btn bg-goldish btn-rounded'>
                          Create & Host
                        </button>
                      </div>

                    </div> : <></>
                  }
                  
                </div>

              </div>
            </div>

            
            <div className='col-md-6' style={{ marginTop: "30px", marginBottom:"30px" }} >
              <div className='row'>
                <div className='col-12' >
                  <h6 className='text-goldish font-light' style={{ fontSize: "20px", marginBottom: "20px" }}>Or Write Game ID and Join Now</h6>
                </div>

                <div className='col-12'>
                  <div className='form-group'>
                    <label>Game ID</label>
                    <input value={gameId} onChange={(e) => { setGameId(e.target.value); setSelectedGame(null)}} className='form-control' style={{ color: "var(--goldish)" }}/>
                  </div>
                </div>

                <div className='col-12 text-end'>
                  <button onClick={checkGameId} className='btn btn-block bg-faint-black mNoMargin'>
                    <IoEnterOutline size={30}/>
                    &nbsp;
                    Join Now
                  </button>
                </div>

                

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  
}
